
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      length: 3,
      onboarding: 0,
      slideGroup: 0,
      interval: null,
      noticia: [],
      loading: true,
    }
  },

  computed: {
    ...mapGetters('noticias', [
      'allNewsWP',
      'mediaSelectedWP',
      'newSelected',
      'WPSelected',
    ]),
    ...mapState({
      noticias: (state) => state.noticias.noticias,
    }),
    isMobileOrTablet() {
      return window.innerWidth <= 768
    },
    randomNews() {
      return this.getRandomNews()
    },

    filteredNews() {
      return this.allNewsWP.slice(1, 3)
    },
  },
  mounted() {
    this.startAutoSlide()
    this.loadNews()
  },
  beforeDestroy() {
    this.stopAutoSlide()
  },
  methods: {
    ...mapActions('noticias', [
      'fetchNewsWP',
      'fetchNewsWPMediaSelected',
      'fetchNewsWPSelected',
    ]),

    async loadNews(page = 1) {
      try {
        await this.fetchNewsWP(page)
        this.noticia = this.allNewsWP.slice(0, 3)
      } catch (error) {
        console.error(error)
      }
    },

    redirectToNewsItem(item) {
      this.$router.push(`/blog/${item.slug}`)
    },

    redirectNoticias() {
      this.$router.push('/noticias')
    },

    getRandomNews() {
      if (this.noticias.length === 0) {
        return null
      }

      let randomIndex
      do {
        randomIndex = Math.floor(Math.random() * this.noticias.length)
      } while (randomIndex === this.noticiaAtualIndex)

      this.noticiaAtualIndex = randomIndex

      return this.noticias[randomIndex]
    },

    startAutoSlide() {
      this.interval = setInterval(() => {
        this.onboarding = (this.onboarding + 1) % this.allNewsWP.length
      }, 5000) // Intervalo de 5 segundos
    },

    stopAutoSlide() {
      clearInterval(this.interval)
    },
  },
}
